"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useMediaQuery_1 = __importDefault(require("../../hooks/useMediaQuery"));
const media_query_utils_1 = require("../../utils/media-query-utils");
function useVibeMediaQuery() {
    const [mediaSize, setMediaSize] = (0, react_1.useState)(media_query_utils_1.SMALL1);
    const [isSmall1, isSmall2, isMedium1, isMedium2, isLarge, isXLarge] = (0, useMediaQuery_1.default)(media_query_utils_1.VIBE_MEDIA_QUERIES);
    (0, react_1.useLayoutEffect)(() => {
        if (isSmall1)
            setMediaSize(media_query_utils_1.SMALL1);
        if (isSmall2)
            setMediaSize(media_query_utils_1.SMALL2);
        if (isMedium1)
            setMediaSize(media_query_utils_1.MEDIUM1);
        if (isMedium2)
            setMediaSize(media_query_utils_1.MEDIUM2);
        if (isLarge)
            setMediaSize(media_query_utils_1.LARGE);
        if (isXLarge)
            setMediaSize(media_query_utils_1.XLARGE);
    }, [isSmall1, isSmall2, isMedium1, isMedium2, isLarge, isXLarge, setMediaSize]);
    return mediaSize;
}
exports.default = useVibeMediaQuery;
useVibeMediaQuery.sizes = media_query_utils_1.MEDIA_QUERY_SIZES;
